<div class="main-container">
  <form #isothermalCharacterizationListForm="ngForm">
    <div class="toolbar-list">

      <div class="toolbar-list-title">
        <div fxLayout="row" fxLayoutAlign="start center">
          <img fxHide.lt-sm src="{{ getThemeIconPath() }}isothermalCharacterization.svg"
            alt="{{ 'isothermalCharacterizationList.title' | translate }}">
          <h1 class="accent-color">{{ 'isothermalCharacterizationList.title' | translate }}</h1>
        </div>

        <div class="breadcrumbs">
          <a href="#">{{ 'common.start.label' | translate }}</a> /
          <span>{{ 'isothermalCharacterizationList.title' | translate }}</span>
        </div>
      </div>

      <div class="toolbar-list-actions">
        <button mat-raised-button (click)="new()" color="accent" [disabled]="disableOfflineButton"
          matTooltip="{{ 'button.disabled.offline' | translate }}" [matTooltipDisabled]="!disableOfflineButton">
          <mat-icon fxHide.lt-sm>add</mat-icon> {{ 'button.new' | translate }}
        </button>
      </div>

      <div class="toolbar-back-button">
        <a (click)="cancel()" mat-button color="accent">
          <mat-icon color="accent">undo</mat-icon> {{ 'button.back' | translate }}
        </a>
      </div>
    </div>

    <app-isothermal-characterization-list-filter (filterEmitter)="doFilter($event)" class="filter-container">
    </app-isothermal-characterization-list-filter>

    <div class="table-container">
      <table #isothermalCharacterizations mat-table matSort [dataSource]="dataSource">

        <!-- client Column -->
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'isothermalCharacterizationList.cols.client' | translate }} </th>
          <td mat-cell *matCellDef="let item"> {{item.client?.name}} </td>
        </ng-container>

        <!-- documentCode Column -->
        <ng-container matColumnDef="documentCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'isothermalCharacterizationList.cols.documentCode' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"> {{item.documentCode}} v.{{item.currentVersion | number:'2.0' }}</td>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'isothermalCharacterizationList.cols.status' | translate }} </th>
          <td mat-cell *matCellDef="let item">
          {{ 'isothermalCharacterizationStatus.' + item.statusTranslation | translate }} </td>
        </ng-container>

        <!-- equipment Column -->
        <ng-container matColumnDef="equipment">
          <th mat-header-cell *matHeaderCellDef> {{ 'isothermalCharacterizationList.cols.equipment' | translate }} </th>
          <td mat-cell *matCellDef="let item">
            <div style="white-space: pre-line;">
              {{ showEquipment(item.equipments) }}
            </div>
          </td>
        </ng-container>

        <!-- serialNum Column -->
        <ng-container matColumnDef="serialNum">
          <th mat-header-cell *matHeaderCellDef> {{ 'isothermalCharacterizationList.cols.serialNum' | translate }} </th>
          <td mat-cell *matCellDef="let item">
            <div style="white-space: pre-line;">
              {{ showSerialNumEquipment(item.equipments) }}
            </div>
          </td>
        </ng-container>

        <!-- internalId Column -->
        <ng-container matColumnDef="internalId">
          <th mat-header-cell *matHeaderCellDef> {{ 'isothermalCharacterizationList.cols.internalId' | translate }}
          </th>
          <td mat-cell *matCellDef="let item">
            <div style="white-space: pre-line;">
              {{ showInternalIdEquipment(item.equipments) }}
            </div>
          </td>
        </ng-container>

        <!-- projectNo Column -->
        <ng-container matColumnDef="projectNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'isothermalCharacterizationList.cols.projectNo' | translate }} </th>
          <td mat-cell *matCellDef="let item">{{ item.projectNo }} </td>
        </ng-container>

        <!-- initWorkDate Column -->
        <ng-container matColumnDef="initWorkDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'isothermalCharacterizationList.cols.initWorkDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let item">
            <div style="white-space: pre-line;">
              {{ item.initWorkDate | fixDateTime }}
            </div>
          </td>
        </ng-container>

        <!-- endWorkDate Column -->
        <ng-container matColumnDef="endWorkDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'isothermalCharacterizationList.cols.endWorkDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let item">
            <div style="white-space: pre-line;">
              {{ item.endWorkDate | fixDateTime }}
            </div>
          </td>
        </ng-container>

        <!-- realizationDate Column -->
        <ng-container matColumnDef="realizationDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'isothermalCharacterizationList.cols.realizationDate' | translate }}
          </th>
          <td mat-cell *matCellDef="let item">
            <div style="white-space: pre-line;">
              {{ item.realizationDate | fixDateTime }}
            </div>
          </td>
        </ng-container>

        <!-- department Column -->
        <ng-container matColumnDef="department">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'isothermalCharacterizationList.cols.department' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"> {{ item.department | translate }} </td>
        </ng-container>

        <!-- Button download Column -->
        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef colspan="3" fxHide.lt-lg>
          {{ 'isothermalCharacterizationList.cols.actions' | translate }} </th>
          <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
            <div matTooltip="{{ 'button.disabled.offline' | translate }}" [matTooltipDisabled]="!disableOfflineButton">
              @if (showDownloadButton(element)) {
                <button mat-icon-button (click)="downloadPdf(element)"
                  [disabled]="disableOfflineButton" matTooltip="{{ 'button.download' | translate }}">
                  <mat-icon>cloud_download</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>

        <!-- Button edit Column -->
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
          <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
            <button mat-icon-button (click)="editRow(element.id)" matTooltip="{{ 'button.edit' | translate }}">
              <mat-icon>mode_edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Button delete Column -->
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
          <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
            <div matTooltip="{{ 'button.disabled.offline' | translate }}" [matTooltipDisabled]="!disableOfflineButton">
              @if (showDeleteButton(element)) {
                <button mat-icon-button (click)="deleteRow(element.id)"
                  [disabled]="disableOfflineButton" matTooltip="{{ 'button.delete' | translate }}">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>

        <!-- Button clone Column -->
        <ng-container matColumnDef="clone">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
          <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
            @if (canClone(element)) {
              <button mat-icon-button (click)="cloneRow(element.id)"
                matTooltip="{{ 'button.clone' | translate }}">
                <mat-icon>folder_copy</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <!-- Button clone Column -->
        <ng-container matColumnDef="clone_characterization">
          <th mat-header-cell *matHeaderCellDef [ngStyle]="{'display': 'none'}"></th>
          <td mat-cell *matCellDef="let element" fxHide.lt-lg class="action">
            <button mat-icon-button (click)="cloneCharacterization(element.id)" [disabled]="showCanCloneCharacterization"
              matTooltip="{{ 'button.clone-execution' | translate }}">
              <mat-icon>file_copy</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Button more Column -->
        <ng-container matColumnDef="more" stickyEnd>
          <th mat-header-cell *matHeaderCellDef fxHide fxShow.lt-lg></th>
          <td mat-cell *matCellDef="let element" fxHide fxShow.lt-lg class="action">

            <mat-menu #appMenu="matMenu" class="moreActions">
              <ng-template matMenuContent let-name="element">
                @if (showDownloadButton(element)) {
                  <button mat-button (click)="downloadPdf(element)"
                    matTooltip="{{ 'button.disabled.offline' | translate }}" [matTooltipDisabled]="!disableOfflineButton"
                    [disabled]="disableOfflineButton">
                    <mat-icon>cloud_download</mat-icon> {{ 'button.download' | translate }}
                  </button>
                }
                <button mat-button (click)="editRow(element.id)">
                  <mat-icon>mode_edit</mat-icon> {{ 'button.edit' | translate }}
                </button>
                @if (showDeleteButton(element)) {
                  <button mat-button (click)="deleteRow(element.id)"
                    matTooltip="{{ 'button.disabled.offline' | translate }}" [matTooltipDisabled]="!disableOfflineButton"
                    [disabled]="disableOfflineButton">
                    <mat-icon>delete</mat-icon> {{ 'button.delete' | translate }}
                  </button>
                }
                @if (canClone(element)) {
                  <button mat-button (click)="cloneRow(element.id)">
                    <mat-icon>folder_copy</mat-icon> {{ 'button.clone' | translate }}
                  </button>
                }
              </ng-template>
            </mat-menu>

            <button mat-icon-button [matMenuTriggerFor]="appMenu" [matMenuTriggerData]="element">
              <mat-icon>more_horiz</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      @if (!hasFiltered) {
        <span class="prefilterMessage">
          <p [innerHtml]="'common.listPlaceholder' | translate | safe: 'html'"> </p>
        </span>
      }
    </div>

    <div class="table-footer-container">
      <div class="actions">
        <button mat-raised-button (click)="exportTable()" class="stroked-primary">
          <mat-icon fxHide.lt-sm>cloud_download</mat-icon> {{ 'button.downloadXls' | translate }}
        </button>
        <a [routerLink]="['.']" [fragment]="'table-container'" class="back-to-top accent-color">
        {{ 'button.backToTop' | translate }} </a>
      </div>
      <div class="paginator">
        <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
          [length]="dataSource.totalItems$ | async" lang="es">
        </mat-paginator>
      </div>
    </div>
  </form>
</div>